import React from 'react';

function PaymentGateway() {
  return <div>PaymentGateway</div>;
}

export default PaymentGateway;
